if (!customElements.get('home-scenne-entry')) {
    class ImageSwiper extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.mySwiper = new Swiper(this.querySelector(`.category_swiper_container`), {
                slidesPerView: 1,
                spaceBetween: 0,
                observer: true,
                touchMove:true,
                resizeObserver: true,
                  autoplay: {
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
    }, 
                lazy: {
                    loadPrevNext: true,
                },
                navigation: {
                    nextEl: this.querySelector(`.swiper-btn-next`),
                    prevEl: this.querySelector(`.swiper-btn-prev`),
                },
                pagination: {
                    el: this.querySelector(`#${this.id} .swiper-pagination`),
                    clickable: true,
                },
                on: {
                    slideChange: this.handleSlideChange.bind(this),
                },
                scrollbar: {
                    el: this.querySelector(`#${this.id} .swiper-scrollbar`),
                    draggable: true,
                },
                breakpoints: {
                  
                    1000: {
                      spaceBetween: 0,
                      slidesPerView: 1,
                    },
                    300: {
                      spaceBetween: 20,
                      slidesPerView: 1.2,
                    },
                  }
            });
            this.initEvent(this.mySwiper);
        }

        /**
         * 轮播图切换事件
         */
        handleSlideChange(swiper) {
            const toIndex = swiper.activeIndex;
            console.log(toIndex);
            $(`#${this.id} .categorys .category_item`).removeClass('active');
            const btn = document.querySelectorAll(`#${this.id} .categorys .category_item`)[toIndex];
            $(btn).addClass('active');
        }
        initEvent(swiper) {
            $(`#${this.id} .categorys .category_item`).mouseenter((e) => {
                if (!$(this).hasClass('active')) {
                    const index = $(e.currentTarget).index();
                    swiper.slideTo(index);
                }
            });
        }
    }

    customElements.define('home-scenne-entry', ImageSwiper);
}

